import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PagesApp } from "./PagesApp";
import { CheckoutRoute } from "./CheckoutRoute";
import { CartProvider } from "@/contexts/CartContext";
import { PageProvider } from "@/contexts/PageContext";

const elem = document.getElementById("root")!;
const app = (
  <BrowserRouter>
    <PageProvider>
      <CartProvider>
        <Routes>
          <Route path="/checkout/:checkoutId/:step?" element={<CheckoutRoute />} />
          <Route path="*" element={<PagesApp />} />
        </Routes>
      </CartProvider>
    </PageProvider>
  </BrowserRouter>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
